import {
  ButtonLooks,
  DialogAnimations,
  FontAlignments,
  FontIcons,
  StandardButton,
  StandardDialog,
  StandardDialogProps,
  StandardText
} from '@brandfolder/react';
import classNames from 'classnames';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

import { BlockTypes } from '@enums/blocks';
import { Block } from '@typings/block';
import { Page } from '@typings/page';

interface ConfirmDeleteDialogProps
  extends Omit<
    StandardDialogProps,
    'children' | 'height' | 'labels' | 'showFooter' | 'title' | 'titleIcon' | 'width'
  > {
  onCancel: () => void;
  onConfirm: () => void;
  block?: Block;
  page?: Page;
}

const UnstyledConfirmDeleteDialog: FunctionComponent<ConfirmDeleteDialogProps> = (props) => {
  const { block, onCancel, onConfirm, page, ...otherProps } = props;

  const title =
    block && block.type === BlockTypes.Section
      ? 'Delete section'
      : block
      ? 'Delete block'
      : page
      ? 'Delete page'
      : '';

  return (
    <StandardDialog
      {...otherProps}
      animation={DialogAnimations.FadeIn}
      className={classNames({
        'confirmation-dialog': true,
        [`${otherProps?.className}`]: !!otherProps?.className
      })}
      height={290}
      titleIcon={FontIcons.Trash}
      labels={{
        closeButtonLabel: 'Close',
        loaderLabel: 'Loading'
      }}
      showFooter={false}
      title={title}
      width={350}
    >
      <StandardText align={FontAlignments.Center}>Are you sure?</StandardText>
      <StandardText align={FontAlignments.Center} className="confirm">
        {block ? (
          <>
            The {block.type} block{' '}
            {block.type === BlockTypes.Section && <>and all blocks within it</>} will be deleted.
          </>
        ) : page ? (
          <>
            The page <strong>{page.name}</strong> and all sections within it will be deleted.
          </>
        ) : null}
      </StandardText>
      <div className="button-group">
        <StandardButton
          className="cancel"
          look={ButtonLooks.Tertiary}
          onClick={() => {
            onCancel();
          }}
        >
          Cancel
        </StandardButton>
        <StandardButton
          look={ButtonLooks.Danger}
          onClick={() => {
            onConfirm();
          }}
        >
          {title}
        </StandardButton>
      </div>
    </StandardDialog>
  );
};

const StyledConfirmDeleteDialog = styled(UnstyledConfirmDeleteDialog)`
  .bf-dialog__body {
    .confirm {
      margin-bottom: 32px;
    }

    .button-group {
      display: flex;
      justify-content: center;
    }

    .cancel {
      margin-right: 12px;
    }
  }
`;

export const ConfirmDeleteDialog: FunctionComponent<ConfirmDeleteDialogProps> = (props) => {
  return <StyledConfirmDeleteDialog {...props} />;
};
